import { render, staticRenderFns } from "./document-preview.vue?vue&type=template&id=c3eddf68&scoped=true"
import script from "./document-preview.vue?vue&type=script&lang=ts"
export * from "./document-preview.vue?vue&type=script&lang=ts"
import style0 from "./document-preview.vue?vue&type=style&index=0&id=c3eddf68&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3eddf68",
  null
  
)

export default component.exports